import {
  INIT_NVQUAL,
  FETCH_NVQUAL_DETAILS_START,
  FETCH_NVQUAL_DETAILS_SUCCESS,
  FETCH_NVQUAL_DETAILS_ERROR,
  FETCH_NVQUAL_DETAILS_SELECTION_START,
  FETCH_NVQUAL_DETAILS_SELECTION_SUCCESS,
  FETCH_NVQUAL_DETAILS_SELECTION_ERROR,
  NVQUAL_UPLOAD_DIALOG,
  POST_NVQUAL_DETAILS_START,
  POST_NVQUAL_DETAILS_SUCCESS,
  POST_NVQUAL_DETAILS_ERROR,
  UPDATE_NVQUAL_REPORT_REVISION,
  UPDATE_NVQUAL_REVISION_NUMBER,
  UPDATE_NVQUAL_STATUS_SOURCE,
  UPDATE_CURRENT_REVISION,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  TOGGLE_CARD_COLLAPSE,
  EXPAND_CARD,
  UPDATE_PROJECT_NVQUAL_STATUS
} from './constants'
import ProjectUploadNvqualReducer from 'containers/Project/FileUploadDialogNvqual/reducer'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'
import EditBoxReducer from 'containers/Project/NvqualSection/EditBox/reducer'
import _ from 'lodash'

const setLoadingTrue = () => true
const setLoadingFalse = () => false
const toggleNvqualUploadDialog = (prev) => !prev

const loadingReducer = createReducer(setLoadingFalse(), {
  [FETCH_NVQUAL_DETAILS_START]: setLoadingTrue,
  [FETCH_NVQUAL_DETAILS_SUCCESS]: setLoadingFalse,
  [FETCH_NVQUAL_DETAILS_ERROR]: setLoadingFalse,
  [FETCH_NVQUAL_DETAILS_SELECTION_START]: setLoadingTrue,
  [FETCH_NVQUAL_DETAILS_SELECTION_SUCCESS]: setLoadingFalse,
  [FETCH_NVQUAL_DETAILS_SELECTION_ERROR]: setLoadingFalse,
  [POST_NVQUAL_DETAILS_START]: setLoadingTrue,
  [POST_NVQUAL_DETAILS_SUCCESS]: setLoadingFalse,
  [POST_NVQUAL_DETAILS_ERROR]: setLoadingFalse,
  [NVQUAL_UPLOAD_DIALOG]: toggleNvqualUploadDialog,
  [FETCH_START]: setLoadingTrue,
  [FETCH_SUCCESS]: setLoadingFalse,
  [FETCH_ERROR]: setLoadingTrue
})

const updateStatusByRevId = (prev, {rev}) => {
  return prev.map(x => x.revision.id === rev.id ?
     {...x, revision: rev}: x)
}

const getStatusSourceTextByKey = (num, statusSource) => {
  if (!num) return ''
  return statusSource.find(x => x.value === num).label
}

const nvqualRevision = createReducer([], {
  [INIT_NVQUAL] : () => [],
  [UPDATE_NVQUAL_REPORT_REVISION]: (prev, { revHeaders }) => revHeaders,
})

const nvqualRevisionNum = createReducer(null, {
  [INIT_NVQUAL]: () => null,
  [UPDATE_NVQUAL_REVISION_NUMBER]: (prev, { num }) => num,
})

const nvqualStatusSource = createReducer([], {
  [INIT_NVQUAL] : () => [],
  [UPDATE_NVQUAL_STATUS_SOURCE]: (prev, { source }) => source
})

const nvqualCurrentRevision = createReducer(null, {
  [INIT_NVQUAL]: () => null,
  [UPDATE_CURRENT_REVISION]: (prev, {rev}) => rev
})

const cardCollapseReducer = createReducer(true, {
  [INIT_NVQUAL] : () => true,
  [TOGGLE_CARD_COLLAPSE]: (prev) => !prev,
  [EXPAND_CARD]: () => false
})

const isClosedReducer = createReducer(null, {
  [INIT_NVQUAL] : () => null,
  [UPDATE_PROJECT_NVQUAL_STATUS] : (prev, { isClosed }) => isClosed
})

export default combineReducers({
  isClosed: isClosedReducer,
  cardCollapse: cardCollapseReducer,
  loading: loadingReducer,
  fileUpload: ProjectUploadNvqualReducer,
  revisionHeaders: nvqualRevision,
  curRevisionNumber: nvqualRevisionNum,
  currentRevision: nvqualCurrentRevision,
  nvqualStatusSource: nvqualStatusSource,
  edit: EditBoxReducer
})
